import { SECTION_HEADING } from '../actions/types'

const initialState = {}

const sectionHeadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SECTION_HEADING:
      return action.payload
    default:
      return state
  }
}

export default sectionHeadingReducer
